// extracted by mini-css-extract-plugin
export default {"Badges":"styles_Badges__5MjxC","HeaderButtonWrapper":"styles_HeaderButtonWrapper__u2Vfd","Icon":"styles_Icon__XC3E5","Button":"styles_Button__U73f2"};